import React from 'react';

// Import official SVG logos
import GrabLogo from '../../assets/logos/grab_logo.svg';
import ShopeeLogo from '../../assets/logos/shopee_logo.svg';
import XanhSMLogo from '../../assets/logos/xanhsm_logo.svg';

interface PlatformLogoProps {
  platform: 'grab' | 'shopee' | 'xanhsm' | 'internal';
  className?: string;
  size?: number;
}

export const PlatformLogo: React.FC<PlatformLogoProps> = ({
  platform,
  className = '',
  size = 20,
}) => {
  // Make Grab and Xanh SM logos bigger
  const getLogoSize = (platform: string) => {
    if (platform === 'grab' || platform === 'xanhsm') {
      return Math.round(size * 1.5); // 50% bigger
    }
    return size;
  };

  const logoSize = getLogoSize(platform);

  const logos = {
    grab: (
      <img
        src={GrabLogo}
        alt="Grab"
        width={logoSize}
        height={logoSize}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    ),
    shopee: (
      <img
        src={ShopeeLogo}
        alt="Shopee"
        width={logoSize}
        height={logoSize}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    ),
    xanhsm: (
      <img
        src={XanhSMLogo}
        alt="Xanh SM"
        width={logoSize}
        height={logoSize}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    ),
    internal: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Internal/Store icon - Building/storefront */}
        <path
          d="M4 21V7L12 3L20 7V21"
          stroke="#6B7280"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M9 21V12H15V21"
          stroke="#6B7280"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M4 12H20"
          stroke="#6B7280"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  };

  return logos[platform] || logos.internal;
};
